import React from 'react';

export function LocationIcon({ size = 20, color = 'currentColor', style, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color, ...style }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5.00065C8.15905 5.00065 6.66667 6.49304 6.66667 8.33398C6.66667 10.1749 8.15905 11.6673 10 11.6673C11.8409 11.6673 13.3333 10.1749 13.3333 8.33398C13.3333 6.49304 11.8409 5.00065 10 5.00065ZM8.33333 8.33398C8.33333 7.41351 9.07953 6.66732 10 6.66732C10.9205 6.66732 11.6667 7.41351 11.6667 8.33398C11.6667 9.25446 10.9205 10.0007 10 10.0007C9.07953 10.0007 8.33333 9.25446 8.33333 8.33398Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.833984C5.87029 0.833984 2.5 4.13289 2.5 8.22982C2.5 9.05778 2.77248 9.96486 3.15387 10.8474C3.54087 11.7429 4.06996 12.6804 4.64797 13.5876C5.80426 15.4025 7.19828 17.1613 8.16706 18.3213C9.12916 19.4733 10.8708 19.4733 11.8329 18.3213C12.8017 17.1613 14.1957 15.4025 15.352 13.5876C15.93 12.6804 16.4591 11.7429 16.8461 10.8474C17.2275 9.96486 17.5 9.05778 17.5 8.22982C17.5 4.13289 14.1297 0.833984 10 0.833984ZM4.16667 8.22982C4.16667 5.07801 6.76592 2.50065 10 2.50065C13.2341 2.50065 15.8333 5.07801 15.8333 8.22982C15.8333 8.72526 15.6614 9.38749 15.3162 10.1863C14.9766 10.9721 14.497 11.8279 13.9464 12.6921C12.8455 14.4201 11.5029 16.1165 10.5537 17.253C10.2579 17.6072 9.74212 17.6072 9.44627 17.253C8.49714 16.1165 7.15449 14.4201 6.05359 12.6921C5.50301 11.8279 5.02338 10.9721 4.6838 10.1863C4.33861 9.38749 4.16667 8.72526 4.16667 8.22982Z"
        fill="currentColor"
      />
    </svg>
  );
}
